import React from 'react';
import AdminLayout from "@/components/layout/admin/adminLayout";
import TableSearch from "@/components/table/tableSearch";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {Button} from "antd";
import {Link, useNavigate} from "react-router-dom";
import {sprintf} from "@/lib/utils/sprintf";
import {URLS} from "@/lib/urls";
import RenderIf from "@/components/render-if";
import PermList from "@/lib/helper/PermList";
import {Can, hasPermissionLink} from "@/components/can/Can";
import {useApiSearchAdminClassroom} from "@/api/classroom";
import ClassroomStatusEnumComponent from "@/components/EnumComponents/ClassroomStatusEnumComponent";
import {MapPinIcon} from "lucide-react";

function AdminClassroomListPage(props) {
    const navigate = useNavigate();


    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'عنوان',
            dataIndex: 'title',
            key: 'title',
            render: (text, record) => (<>
                <div className="flex gap-1">
                    <RenderIf condition={record?.latitude && record?.longitude}>
                        <div title={'موقعیت جغرافیایی ثبت شده است'}>
                            <MapPinIcon className={'text-red-400 text-xs w-[18px]'}/>
                        </div>
                    </RenderIf>
                    <span>{text}</span>
                </div>

            </>)
        },


        {
            title: 'وضعیت',
            dataIndex: 'status',
            key: 'status',
            responsive: ['md'],

            render: (text, record) => <>
                <div className="flex">

                    <ClassroomStatusEnumComponent text={text}/>
                </div>

            </>
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'datecreated',
            key: 'datecreated',
            responsive: ['md'],

            render: (text, record) => {

                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss')
            }
        },


        {
            title: ' ',
            dataIndex: 'id',
            key: 'id',
            render: (text, record) => {
                return (<Link
                    to={hasPermissionLink(PermList.CLASSROOM_EDIT, sprintf(URLS.admin.classroom.edit, {id: record.id}))}>
                    <Button size={'small'} variant={'filled'}
                            color={'primary'}>ویرایش</Button>
                </Link>)
            }
        },
    ];
    return (
        <AdminLayout backTo={URLS.admin.dashboard} pageTitle={'لیست محل‌های برگزاری کلاس'}>

            <TableSearch
                searchInput={true}
                addButton={
                    <div className={'flex justify-end gap-1'}>

                        <Link to={URLS.admin.classroom.map}>
                            <Button
                                // color={'secondary'}
                                variant={'dashed'}
                                size={'medium'}
                            >
                                <div className={'hidden md:flex'}>
                                    نمایش نقشه
                                </div>
                                <div className={'flex md:hidden'}>
                                    نقشه
                                </div>
                            </Button>
                        </Link>
                        <Can permission={PermList.CLASSROOM_ADD}>
                            <Button
                                color={'primary'}
                                variant={'solid'}
                                size={'medium'}
                                onClick={() => navigate(URLS.admin.classroom.create)}>
                                <div className={'hidden md:flex'}>
                                    افزودن محل برگزاری جدید
                                </div>
                                <div className={'flex md:hidden'}>
                                    +
                                </div>

                            </Button>
                        </Can>


                    </div>
                }
                apiFn={useApiSearchAdminClassroom}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </AdminLayout>
    );
}

export default AdminClassroomListPage;